import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/header";
import { useLocation } from "react-router-dom";
import "./setprivilages.css";

const SetPrivileges = () => {
    const location = useLocation();
    const editUser = location.state?.user || null; // Get passed user from Settings.js

    const [empId, setEmpId] = useState("");
    const [empName, setEmpName] = useState("");
    const [empEmail, setEmpEmail] = useState("");
    const [privileges, setPrivileges] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [selectedPrivileges, setSelectedPrivileges] = useState([]);
    const [role, setRole] = useState("user"); // default
    const [isSaving, setIsSaving] = useState(false);

    // Fetch all privileges
    // useEffect(() => {
    //     const fetchPrivileges = async () => {
    //         try {
    //             const res = await fetch("/api/privileges");
    //             const data = await res.json();
    //             setPrivileges(data);
    //         } catch (err) {
    //             console.error("Error fetching privileges:", err);
    //         }
    //     };
    //     fetchPrivileges();
    // }, []);

    // Prefill employee info and privileges if editing
    
    useEffect(() => {
        const loadData = async () => {
            try {
                if (editUser) {
                    setEmpId(editUser.emp_id || "");
                    setEmpName(editUser.user_name || "");
                    setEmpEmail(editUser.user_email_id || "");
                    setOrgId(editUser.org_id || ""); // ✅ ensure orgId is stored
                    setRole(editUser.role || "user");
                    if (privileges.length > 0) {
                        let preselected = [];

                        if (typeof editUser.privilege_name === "string") {
                            preselected = editUser.privilege_name
                                .replace(/[{}"]/g, "")
                                .split(",")
                                .map((p) => p.trim());
                        } else if (Array.isArray(editUser.privilege_name)) {
                            preselected = editUser.privilege_name;
                        }

                        const ids = privileges
                            .filter((p) => preselected.includes(p.privilege_name))
                            .map((p) => p.id);

                        setSelectedPrivileges(ids);
                    }
                    return;
                }

                // Fetch org info when empId is typed or selected
                if (empId.trim() !== "") {
                    const res = await fetch(`/api/employees/${empId}`);
                    const data = await res.json();

                    if (data) {
                        setEmpName(data.emp_name || "");
                        setEmpEmail(data.emp_email_id || "");
                        setOrgId(data.org_id || ""); // ✅ fix missing orgId
                    }
                } else {
                    setEmpName("");
                    setEmpEmail("");
                    setOrgId("");
                }
            } catch (err) {
                console.error("❌ Error fetching employee:", err);
                setEmpName("");
                setEmpEmail("");
                setOrgId("");
            }
        };

        loadData();
    }, [empId, editUser, privileges]);
    // Fetch employee name & email based on EMP ID (only when not editing)
    useEffect(() => {
        if (editUser) return; // skip if editing
        if (empId.trim() === "") {
            setEmpName("");
            setEmpEmail("");
            return;
        }

        const fetchEmployee = async () => {
            try {
                const res = await fetch(`/api/employees/${empId}`);
                const data = await res.json();
                setEmpName(data.emp_name || "");
                setEmpEmail(data.emp_email_id || "");
                setOrgId(data.org_id || "");
            } catch (err) {
                console.error("Error fetching employee:", err);
                setEmpName("");
                setEmpEmail("");
            }
        };
        fetchEmployee();
    }, [empId, editUser]);

    // Handle checkbox toggle
    const handleCheckboxChange = (privId) => {
        setSelectedPrivileges((prev) =>
            prev.includes(privId) ? prev.filter((id) => id !== privId) : [...prev, privId]
        );
    };

    // Handle save user & privileges
    // const handleSave = async () => {
    //     if (isSaving) return; // Prevent multiple clicks

    //     if (!empId.trim() || !empName || !empEmail) {
    //         alert("Please enter a valid EMP ID and ensure employee exists.");
    //         return;
    //     }

    //     if (!selectedPrivileges.length) {
    //         alert("Please select at least one privilege.");
    //         return;
    //     }

    //     const safeOrgId = Number(orgId) || 1;
    //     if (!safeOrgId || isNaN(safeOrgId)) {
    //         alert("Missing organization. Please verify the employee’s organization.");
    //         return;
    //     }

    //     try {
    //         setIsSaving(true);

    //         const userRes = await fetch("/api/eblogin/add", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 user_name: empName,
    //                 user_email_id: empEmail,
    //                 password: "default123",
    //                 role: role,
    //                 emp_id: empId,
    //                 org_id: safeOrgId,
    //             }),
    //         });

    //         const userData = await userRes.json();

    //         if (!userData.success) {
    //             alert(userData.message || "Failed to create/update user.");
    //             return;
    //         }

    //         const privRes = await fetch(
    //             "/api/privileges/assign",
    //             {
    //                 method: "POST",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify({
    //                     user_email_id: empEmail,
    //                     privileges: selectedPrivileges,
    //                     emp_id: empId,
    //                 }),
    //             }
    //         );

    //         const privData = await privRes.json();

    //         if (!privData.success) {
    //             alert(privData.message || "Failed to assign privileges.");
    //             return;
    //         }

    //         if (editUser) {
    //             alert("✅ User and privileges updated successfully!");
    //         } else {
    //             alert("✅ User and privileges saved successfully!");
    //             setEmpId("");
    //             setEmpName("");
    //             setEmpEmail("");
    //             setSelectedPrivileges([]);
    //         }

    //     } catch (err) {
    //         console.error(err);
    //         alert("Server error while saving user and privileges.");
    //     } finally {
    //         setIsSaving(false);
    //     }
    // };

const handleSave = async () => {
    if (isSaving) return; // Prevent multiple clicks

    if (!empId.trim() || !empName || !empEmail) {
        alert("Please enter a valid EMP ID and ensure employee exists.");
        return;
    }

    const safeOrgId = Number(orgId) || 1;
    if (!safeOrgId || isNaN(safeOrgId)) {
        alert("Missing organization. Please verify the employee’s organization.");
        return;
    }

    try {
        setIsSaving(true);

        const userRes = await fetch("/api/eblogin/add", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                user_name: empName,
                user_email_id: empEmail,
                password: "default123",
                role: role,
                emp_id: empId,
                org_id: safeOrgId,
            }),
        });

        const userData = await userRes.json();

        if (!userData.success) {
            alert(userData.message || "Failed to create/update user.");
            return;
        }

        if (editUser) {
            alert("✅ User updated successfully!");
        } else {
            alert("✅ User saved successfully!");
            setEmpId("");
            setEmpName("");
            setEmpEmail("");
            setSelectedPrivileges([]);
        }

    } catch (err) {
        console.error(err);
        alert("Server error while saving user.");
    } finally {
        setIsSaving(false);
    }
};


    return (
        <div className="privileges-page">
            <aside className="sidebar">
                <Header />
            </aside>

            <div className="privileges-container">
                <h2 className="privileges-title">{editUser ? "Edit Privileges" : "Set Privileges"}</h2>

                <div className="emp-section">
                    <div className="emp-field">
                        <label htmlFor="empid" className="emp-label">EMP ID</label>
                        <input
                            type="text"
                            id="empid"
                            className="emp-input"
                            value={empId}
                            onChange={(e) => setEmpId(e.target.value)}
                            placeholder="Enter EMP ID"
                            readOnly={!!editUser} // Prevent changing EMP ID when editing
                        />
                    </div>

                    <div className="emp-field">
                        <label htmlFor="empname" className="emp-label">EMP Name</label>
                        <input
                            type="text"
                            id="empname"
                            className="emp-input"
                            value={empName}
                            readOnly
                            placeholder="Employee name will appear"
                        />
                    </div>

                    <div className="emp-field">
                        <label htmlFor="empemail" className="emp-label">EMP Email</label>
                        <input
                            type="text"
                            id="empemail"
                            className="emp-input"
                            value={empEmail}
                            readOnly
                            placeholder="Employee email will appear"
                        />
                    </div>
                    <div className="emp-field">
                        <label htmlFor="role" className="emp-label">Role</label>
                        <select
                            id="role"
                            className="emp-input"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="user">user</option>
                            <option value="admin">admin</option>
                        </select>
                    </div>


                    <div className="emp-field hidden">
                        <label htmlFor="orgid" className="emp-label">Organization ID</label>
                        <input
                            type="text"
                            id="orgid"
                            className="emp-input"
                            value={orgId}
                            readOnly
                            placeholder="Organization ID will appear"
                        />
                    </div>

                </div>

                {/* <div className="privileges-list">
                    {privileges.length > 0 ? (
                        privileges.map((priv) => (
                            <div className="privilege-card" key={priv.id}>
                                <input
                                    type="checkbox"
                                    id={`priv-${priv.id}`}
                                    className="privilege-checkbox"
                                    checked={selectedPrivileges.includes(priv.id)}
                                    onChange={() => handleCheckboxChange(priv.id)}
                                />
                                <div className="privilege-text">
                                    <label htmlFor={`priv-${priv.id}`} className="privilege-name">
                                        {priv.privilege_name}
                                    </label>
                                    <p className="privilege-desc">{priv.description}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="no-data">No privileges found.</p>
                    )}
                </div> */}

                <button
                    className={`save-btn ${isSaving ? "loading" : ""}`}
                    onClick={handleSave}
                    disabled={isSaving}
                >
                    {isSaving
                        ? editUser
                            ? "Updating..."
                            : "Saving..."
                        : editUser
                            ? "Update User & Privileges"
                            : "Save User & Privileges"}
                </button>

            </div>
        </div>
    );
};

export default SetPrivileges;
